import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {InlineUserDashboardTab, InlineUserDashboardTabStyle} from "./InlineUserDashboardTab";
import {InlineUserDashboardSection} from "../components/InlineUserDashboardSection";
import {Messages} from "../../../../Messages";
import {accessDashboardURLFromIFrame, collapseIframe} from "../../../../widget/misc/WidgetUtils";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {Link} from "../../../../../stem-core/src/ui/UIPrimitives";
import {PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {PaymentMethodInlineMenu} from "../../../../website/authenticated/pages/account/components/payment-method/PaymentMethodInlineMenu.jsx";
import {PlusIcon} from "../../../../../core/ui/SVGElements.jsx";
import {UserAddressStore} from "../../../../../client/state/UserAddressStore";
import {AddressListItem} from "../../../../website/authenticated/pages/account/components/address/AddressListItem";
import {authService, userService} from "../../../../../client/connection/Services";
import {SubscriptionStore} from "../../../../../client/state/SubscriptionStore";
import {ADDRESS_PANEL_URL, INLINE_USER_DASHBOARD_URLS, PAYMENT_DETAILS_PANEL_URL} from "../../../PanelConstants";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {CARD_SECTION_STATE, PaymentMethodController} from "../../../flows/PaymentMethodController.js";
import {ADDRESS_SECTION_STATE} from "../../panels/address/AddressPanel";
import {iFrameConnection} from "../../../../services/IFrameConnection";
import {IFrameMessages} from "../../../../../blink-sdk/messaging/IFrameMessages";
import {BLINK_PAY_URL} from "../../../../Constants";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {MakeMerchantUserResourcesAccessLink} from "../../../../common/MerchantUserResourcesAccessLink";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../../blink-sdk/Constants";
import {BlinkInput} from "../../../../ui/Input";
import {UserProfileStore} from "../../../../../client/state/UserProfileStore";
import {authFormService} from "../../../../services/AuthFormService";
import {Controller} from "../../../flows/Controller.js";
import {AddressController} from "../../../flows/AddressController.js";
import {Flow} from "../../../flows/FlowState.js";
import {LinkButton} from "../../../../../core/ui/LinkButton.jsx";


class AccountAddressListItem extends AddressListItem {
    getMenuItems() {
        return super.getMenuItems({
            allowEdit: !iFrameMerchantService.isMerchant(TNR_ALIAS) // TODO this should be in the base class, so we don't modify an address used by one of these merchants
        });
    }

    promptToRoute(route) {
        const {address} = this.options;

        if (SubscriptionStore.getActiveWithAddress(address).length) {
            Router.changeURL(INLINE_USER_DASHBOARD_URLS.addressInUsage);
            return;
        }
        Controller.address = new AddressController({
            selectedAddress: address,
            addressSectionState: ADDRESS_SECTION_STATE.editAddress,
            onSelectSuccess: () => Router.back(),
            onSelectCancel: () => Router.back(),
        });
        Router.changeURL(route);
    }

    promptEdit() {
        this.promptToRoute(ADDRESS_PANEL_URL);
    }

    promptDelete() {
        this.promptToRoute(INLINE_USER_DASHBOARD_URLS.removeAddress);
    }
}


class InlineUserDashboardAccountTabStyle extends InlineUserDashboardTabStyle {
    @styleRule
    addNew = {
        ">*": {
            display: "inline-block",
        },
        ">:last-child": {
            marginLeft: 8,
        },
    };

    @styleRule
    address = {
        padding: "12px 0",
    };

    @styleRule
    listItem = {
        ":not(:last-child)": {
            borderBottom: "1px solid #E5E5E5",
        }
    };

    @styleRule
    label = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRule
    logOutLinkContainer = {
        paddingTop: 12,
        textAlign: "center",
    };
}

@autoredraw(PaymentMethodStore, UserAddressStore, UserProfileStore)
@registerStyle(InlineUserDashboardAccountTabStyle)
export class InlineUserDashboardAccountTab extends InlineUserDashboardTab {
    accountEditMode = false;

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.accountPage,
        }
    }

    addPaymentMethodClick() {
        Controller.paymentMethod = new PaymentMethodController({
            cardSectionState: CARD_SECTION_STATE.payWithAddedCard,
            getPayWithAddedCardButtonLabel: () => Messages.addCard,
            getScope: () => PaymentMethodStore.Scope.PUBLIC,
            onSelectSuccess: () => Router.back(),
        });
        Router.changeURL(PAYMENT_DETAILS_PANEL_URL);
    }

    addAddressClick() {
        Controller.address = new AddressController({
            addressSectionState: ADDRESS_SECTION_STATE.continueWithAddedAddress,
            continueLabel: Messages.addNewAddress,
            onSelectSuccess: () => Router.back(),
            onSelectCancel: () => Router.back(),
        });
        Router.changeURL(ADDRESS_PANEL_URL);
    }

    render() {
        const {styleSheet} = this;
        const extraPaymentMethodCount = iFrameUserDataService.getExtraPaymentMethodCount();
        const extraAddressCount = iFrameUserDataService.getExtraUserAddressCount();
        const canEditProfile = !authService.token.usingMerchantToken || iFrameUserDataService.canEditProfile;

        // TODO @cleanup this whole inline section needs to be split up
        return [
            <InlineUserDashboardSection
                titleMessage={Messages.personalDetailsTitle}
                secondaryActionMessage={this.accountEditMode ? Messages.cancel : null}
                secondaryActionFunction={this.accountEditMode ? (() => {
                    this.accountEditMode = false;
                    this.redraw();
                }) : null}
                actionMessage={this.accountEditMode ? Messages.save : Messages.edit}
                actionFunction={() => {
                    if (!canEditProfile) {
                        iFrameConnection.sendToSDK(IFrameMessages.REDIRECT_TO_URL,
                            {url: BLINK_PAY_URL + "/account", newTab: true});
                        return;
                    }
                    if (this.accountEditMode) {
                        this.saveAccountEdit();
                    } else {
                        this.accountEditMode = true;
                        this.redraw();
                        this.nameInput.focusToEnd();
                    }
                }}>
                {
                    this.accountEditMode
                        ? <BlinkInput ref="nameInput" testId="nameInput"
                                      label={Messages.name} initialValue={userService.getUserName()}
                                      inputAttributes={{placeholder: Messages.name}}/>
                        : [
                            <div className={styleSheet.label}>{Messages.name}</div>,
                            <div className={styleSheet.textSection}>{userService.getUserName()}</div>,
                        ]
                }
                {
                    this.accountEditMode
                        ? <BlinkInput ref="emailInput" testId="emailInput"
                                      label={Messages.email} initialValue={userService.getUserEmail() || ""}
                                      inputAttributes={{placeholder: Messages.email}} />
                        : [
                            <div className={styleSheet.label}>{Messages.email}</div>,
                            <div className={styleSheet.textSection}>{userService.getUserEmail()}</div>,
                        ]
                }
            </InlineUserDashboardSection>,

            <InlineUserDashboardSection titleMessage={Messages.myAddressesTitle}>
                <div>
                    {UserAddressStore.all().map(address =>
                        <AccountAddressListItem className={styleSheet.listItem + styleSheet.address}
                                                address={address}/>)}
                </div>
                <LinkButton className={styleSheet.addNew} onClick={() => this.addAddressClick()}>
                    <PlusIcon size={12.25} color={"currentColor"}/>
                    <span>{Messages.addNew}</span>
                </LinkButton>
                {MakeMerchantUserResourcesAccessLink(extraAddressCount)}
            </InlineUserDashboardSection>,

            !iFrameMerchantService.isCDSPaymentMethod() &&
            <InlineUserDashboardSection titleMessage={Messages.paymentMethodsTitle}>
                <div>{PaymentMethodStore.getAvailablePaymentMethods().map(paymentMethod =>
                    <PaymentMethodInlineMenu
                        className={styleSheet.listItem}
                        paymentMethod={paymentMethod}
                        onRemoveAction={(paymentMethod) => {
                            Flow.dashboard.card = paymentMethod;
                            Router.changeURL(INLINE_USER_DASHBOARD_URLS.removeCard);
                        }}
                    />)}</div>
                <LinkButton className={styleSheet.addNew} onClick={() => this.addPaymentMethodClick()}>
                    <PlusIcon size={12.25} color={"currentColor"}/>
                    <span>{Messages.addNew}</span>
                </LinkButton>
                {MakeMerchantUserResourcesAccessLink(extraPaymentMethodCount)}
                </InlineUserDashboardSection>,

            !iFrameMerchantService.isMerchant(TNR_ALIAS) && <InlineUserDashboardSection titleMessage={Messages.myDashboard}>
                <div className={styleSheet.textSection}>
                    {Messages.dashboardExternalLinkText}
                    <Link
                        href="/"
                        newTab
                        value={Messages.blinkDashboard}
                        onClick={accessDashboardURLFromIFrame}
                    />.
                </div>
            </InlineUserDashboardSection>,

            <div className={styleSheet.logOutLinkContainer}>
                <LinkButton
                    label={Messages.logOut}
                    onClick={async () => {
                        collapseIframe();
                        await authService.logout();
                        // Not specifying a URL here determines the merchant's current page to refresh
                        iFrameConnection.sendToSDK(IFrameMessages.REDIRECT_TO_URL, {
                            logOut: true,
                        });
                    }}
                />
            </div>
        ];
    }

    async saveAccountEdit() {
        const newEmail = this.emailInput.getValue().trim();
        const requestedEmailChange = await userService.requestUpdateUserData(this.nameInput.getValue(), newEmail);
        this.accountEditMode = false;
        this.redraw();
        if (requestedEmailChange) {
            authFormService.changeToEmailAddress = newEmail;
            Router.changeURL(INLINE_USER_DASHBOARD_URLS.changeEmailConfirmationCode);
        }
    }
}
